import { classNames } from 'libs/growth-platform-brand-system-v2/src/utils/style';
import React from 'react';

const Separator = () => {
  return (
    <div className={classNames('PriceBreakdown_Separator', 'w-full h-[1px] bg-[#E8E8EC]')} />
  );
};

export default Separator;
